<template>
  <div class="operator simple">
    <hot-spot v-if="canBuy" @btnClick="catchPlusTap" />
    <div v-if="canBuy" class="mc-icon-wrap">
      <img
        v-if="showAddImg"
        src="@/images/addCart/buy_quick.png"
        class="buy-quick"
      />
      <btn-config
        v-else
        :width="btnWidth"
        :has-bg-img="canBuy"
        :icon-name="'jiahaobai'"
        :icon-size="'16px'"
        :has-background="!canBuy"
        :bg-color="'#d9d9d9'"
      />
      <p v-if="showCount && count" :class="['count']">
        {{ count > 99 ? '99+' : `${count}` }}
      </p>
    </div>
  </div>
</template>
<script>
import HotSpot from './hotSpot'
import BtnConfig from './btnConfig'
export default {
  name: 'SimpleComp',
  components: {
    BtnConfig,
    HotSpot
  },
  props: {
    canBuy: {
      type: Boolean,
      default: false
    },
    showCount: {
      type: Boolean,
      default: false
    },
    showAddImg: {
      type: Boolean,
      default: false
    },
    count: {
      type: Number,
      default: 0
    },
    btnWidth: {
      type: Number,
      default: 0.52
    }
  },
  data() {
    return {}
  },
  methods: {
    catchPlusTap() {
      this.$emit('add')
    }
  }
}
</script>

<style lang="scss" scoped>
.operator {
  position: relative;

  min-height: 0.52rem;

  font-size: 0;

  .mc-icon-wrap {
    position: relative;
    .buy-quick {
      width: 0.88rem;
      height: 0.52rem;
    }

    .count {
      display: inline-block;

      position: absolute;
      top: 0;
      right: 0;
      transform: translate(20%, -50%);

      min-width: 0.32rem;
      height: 0.32rem;
      padding: 0 0.1rem;

      background-color: #ff5c00;
      border-radius: 0.32rem;

      font-size: 0.2rem;
      line-height: 0.32rem;
      text-align: center;
      white-space: nowrap;
      vertical-align: top;
      color: #fff;
      box-sizing: border-box;
    }
  }
}
</style>
